<script>
export default {
  name: 'ErrorIcon',
  props: {
    tooltipHTML: String
  }
}
</script>

<template>
  <span
    class="material-symbols-outlined error-icon"
    :title="tooltipHTML"
    v-b-tooltip.html="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
  >
    warning
  </span>
</template>

<style scoped lang="scss">
.error-icon {
  width: 22px;
  text-align: center;
  font-size: 19px;
  color: $iconColorError;
  cursor: default;
}
</style>
